import React from "react";
import { FaCogs, FaRobot, FaBuilding, FaProjectDiagram } from "react-icons/fa";

export function WorkflowAutomation() {
  const cards = [
    {
      name: "Business Process Automation",
      description: "Streamline operations with intelligent workflows for CRM, email, calendar, and project management integration",
      icon: FaProjectDiagram,
      gradient: "from-blue-500 to-cyan-500",
    },
    {
      name: "Custom AI Workflows",
      description: "Tailored automation solutions with custom integrations, specialized nodes, and AI-powered decision making",
      icon: FaRobot,
      gradient: "from-purple-500 to-pink-500",
    },
    {
      name: "Enterprise Workflow Solutions",
      description: "End-to-end workflow implementation with advanced AI capabilities, custom development, and enterprise system integration",
      icon: FaBuilding,
      gradient: "from-orange-500 to-red-500",
    },
  ];

  return (
    <section className="relative bg-gray-900 py-24">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{ 
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23FFFFFF\' fill-opacity=\'0.1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          backgroundSize: '30px 30px'
        }} />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Intelligent Workflow Automation with n8n
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-gray-300">
            Transform your business operations with AI-powered workflow automation
          </p>
        </div>

        {/* Main Feature Card */}
        <div className="mt-12">
          <div className="relative overflow-hidden rounded-2xl bg-gray-800 p-8">
            <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 opacity-20 blur-2xl" />
            <div className="relative flex items-start gap-6">
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-500 to-purple-500">
                <FaCogs className="h-8 w-8 text-white" aria-hidden="true" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-white">AI Workflow Automation</h3>
                <p className="mt-2 text-gray-300">
                  Accelerate your business operations with intelligent workflows powered by n8n and AI integration. From basic automation to custom enterprise solutions.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Supporting Cards */}
        <div className="mt-12">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {cards.map((card) => (
              <div key={card.name} className="relative overflow-hidden rounded-2xl bg-gray-800 p-8">
                <div className={`absolute -right-8 -top-8 h-32 w-32 rounded-full bg-gradient-to-br ${card.gradient} opacity-20 blur-2xl`} />
                <div className="relative flex flex-col items-start gap-4">
                  <div className={`flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br ${card.gradient}`}>
                    <card.icon className="h-6 w-6 text-white" aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">{card.name}</h3>
                    <p className="mt-2 text-sm text-gray-300">{card.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-12 text-center">
          <a
            href="/workflow-solutions"
            className="inline-flex items-center justify-center rounded-md bg-gradient-to-r from-blue-500 to-purple-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:from-blue-600 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900"
          >
            Explore Workflow Solutions
          </a>
        </div>
      </div>
    </section>
  );
}
